import React from 'react';
import Navbar from '../../components/Navbar2';
import Contact from '../../components/Contact';
import AllPlans from '../../components/AllPlans';
import './index.css';

const CollectionsPage = () => {
  return (
    <div className="digital-page">
      <Navbar />

      {/* Hero Section */}
      <div className="digital-hero">
        <div className="digital-hero-overlay" />
        <div className="digital-hero-content">
          <p className="digital-hero-label">Luxury Collections</p>
          <h1 className="digital-hero-title">
            Our Villa
            <br />
            Collections
          </h1>
          <p className="digital-hero-sub">
            Discover our curated portfolio of luxury villas — each collection thoughtfully crafted for a unique lifestyle experience.
          </p>
        </div>
      </div>

      {/* Collections Grid */}
      <AllPlans />

      <Contact />
    </div>
  );
};

export default CollectionsPage;
